let API_HOST = 'http://localhost:8080'
if (process.env.VUE_APP_ENV === 'production') {
  API_HOST = 'https://api.quickreceipts.co'
} else if (process.env.VUE_APP_ENV === 'staging') {
  API_HOST = 'https://api.quickreceipts.co'
}
const API_BASE_URL = '/api'

const RECEIPT_API_ENDPOINTS = {
  KEY_CREATE: API_HOST + API_BASE_URL + '/key/generate',
  KEY_EDIT: API_HOST + API_BASE_URL + '/key/update',
  KEY_DELETE: API_HOST + API_BASE_URL + '/key/delete',
  RECEIPT_LOAD: API_HOST + API_BASE_URL + '/receipt/load',
}

const STRIPE_API_ENDPOINTS = {
  CUSTOMER_CREATE: API_HOST + API_BASE_URL + '/stripe/createCustomer',
  CUSTOMER_GET: API_HOST + API_BASE_URL + '/stripe/getCustomer',
  SUBSCRIPTION_CREATE: API_HOST + API_BASE_URL + '/stripe/createSubscription',
  SUBSCRIPTION_GET: API_HOST + API_BASE_URL + '/stripe/getSubscription',
  SUBSCRIPTION_UPDATE: API_HOST + API_BASE_URL + '/stripe/updateSubscription',
  CARDS_LIST: API_HOST + API_BASE_URL + '/stripe/listCards',
  CARD_GET: API_HOST + API_BASE_URL + '/stripe/getCard',
  CARD_SUBMIT: API_HOST + API_BASE_URL + '/stripe/submitCard',
  INVOICES_LIST: API_HOST + API_BASE_URL + '/stripe/listInvoices',
}

export {
  STRIPE_API_ENDPOINTS,
  RECEIPT_API_ENDPOINTS,
}
